/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line

  const ENGRAVING_VARIANT_ID = 46828919685402;

  const getAddToCartButton = () =>
    $('.product-add-to-cart [data-add-to-cart], .product__submit__buttons [data-add-to-cart]');

  const handleSeeInStoreClick = (e) => {
    try {
      const productTitle = $('.product__title').text();
      localStorage.setItem('seeInStoreTitle', productTitle);

      const productSku = window.ShopifyAnalytics.meta.product.variants[0].sku;
      localStorage.setItem('seeInStoreSku', productSku);

      const productLink = document.location.href;
      localStorage.setItem('seeInStoreLink', productLink);

      const productImage = $('.product-single__media img').attr('src');
      localStorage.setItem('seeInStoreImg', productImage);

      const el = e.currentTarget;
      const isRCProduct = el.hasAttribute('data-rc-product') || el.closest('[data-rc-product]') !== null;

      const skuParam = encodeURIComponent(productSku);
      const baseUrl = isRCProduct ? '/pages/rc-see-in-store' : '/pages/see-in-store';

      window.location.href = `${baseUrl}?sku=${skuParam}`;

    } catch (err) {
      console.error('error caught in handleSeeInStoreClick() in custom.js, err: ', err);
    }
  }

  const populateSeeInStore = () => {
    try {
      const productTitle = localStorage.getItem('seeInStoreTitle');
      const productSku = localStorage.getItem('seeInStoreSku');
      const productLink = localStorage.getItem('seeInStoreLink');
      const productImage = localStorage.getItem('seeInStoreImg');

      $('.see-in-store-product-selected').text(productTitle);
      $('.see-in-store-product a .product-name').text(productTitle);
      $('.see-in-store-product a').attr('href', productLink);
      $('.see-in-store-product-sku').text(productSku);
      $('.see-in-store-product img').attr('src', productImage);
    } catch (err) {
      console.error('error caught in populateSeeInStore() in custom.js, err: ', err);
    }
  }

  const handleEngravingClick = (e) => {
    const $btn = getAddToCartButton();

    if ($(e.target).is(':checked')) {
      $('.engraving-textbox-container').removeClass('titan-hide');

      if (!$('.engraving-textbox-container input').val().length) {
        $btn.prop('disabled', true);
      }
    } else {
      $('.engraving-textbox-container').addClass('titan-hide');
      $btn.prop('disabled', false);
    }
  }

  const handleEngravingText = (e) => {
    getAddToCartButton().prop('disabled', !e.target.value.length);
  }

  let pendingEngraving = null;
  let pendingEngravingTimer = null;

  const handleAddToCart = () => {
    try {
      const engravingText = $('.engraving-textbox-container input').val();
      const wantsEngraving =
        $('.engraving-checkbox-container input').is(':checked') && engravingText.length;

      clearTimeout(pendingEngravingTimer);

      if (!wantsEngraving) {
        pendingEngraving = null;
        return;
      }

      pendingEngraving = {
        text: engravingText,
        associatedSku: window.ShopifyAnalytics?.meta?.product?.variants?.[0]?.sku || ''
      };

      pendingEngravingTimer = setTimeout(() => {
        pendingEngraving = null;
      }, 8000);
    } catch (err) {
      console.error('error caught in handleAddToCart() in custom.js, err: ', err);
    }
  }

  const addPendingEngravingToCart = async () => {
    if (!pendingEngraving) return;

    const properties = pendingEngraving;
    pendingEngraving = null;
    clearTimeout(pendingEngravingTimer);

    try {
      const result = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: ENGRAVING_VARIANT_ID,
          quantity: 1,
          properties
        })
      });

      const data = await result.json();

      if (!result.ok || data.status) {
        throw new Error(data.description || `Shopify returned ${result.status}`);
      }

      if (window.cart && typeof window.cart.getCart === 'function') {
        window.cart.getCart();
      }
    } catch (err) {
      console.error('error adding engraving to cart, err: ', err);
    }
  }

  const hideRingSizes = () => {
    const $selector = $('#ring-size-selector');
    const $gender = $('#hidden-gender-metafield').text();
    const variant = ShopifyAnalytics?.meta?.product?.variants?.[0];
    const vendor = ShopifyAnalytics?.meta?.product?.vendor || '';
    const sku = variant?.sku || '';
    const variantName = variant?.name || '';
    const dataRingSizeRaw = $selector.attr('data-ring-size');

    const removeOptionsExcept = (keepValue) => {
      $selector.find('option').each(function () {
        if ($(this).val() !== keepValue) {
          $(this).remove();
        }
      });
      $selector.val(keepValue);
    };

    const removeOptions = (valuesToRemove, fallbackValue = null) => {
      valuesToRemove.forEach(value => {
        $selector.find(`option[value="${value}"]`).remove();
      });
      if (fallbackValue) {
        $selector.val(fallbackValue);
      }
    };

    const normalizeDataRingSize = (size) => {
      if (size.includes('.5')) return size.split('.')[0] + ' 1/2';
      if (size.includes('.')) return size.split('.')[0];
      return size;
    };

    // 1. From variant name
    if (variantName.includes('(size')) {
      // Get the content inside "(size ...)"
      const sizeBlock = variantName.match(/\(size\s+([^)]*)\)/i);
      if (sizeBlock) {
        const s = sizeBlock[1];

        // 1) Fractional half: 7 1/2, 7-1/2, 7½ (including Unicode fraction slash 1⁄2)
        let m = s.match(/(\d+)\s*(?:-|\s)?\s*(?:½|1\/2|1\u20442)/);
        if (m) {
          const ringSize = (parseInt(m[1], 10) + 0.5).toString();
          return removeOptionsExcept(ringSize);
        }

        // 2) Fallback: first number (handles 7, 12.5, etc.)
        m = s.match(/(\d+(?:\.\d+)?)/);
        if (m) {
          const ringSize = m[1];
          return removeOptionsExcept(ringSize);
        }
      }
    }

    // 2. From data attribute
    if (dataRingSizeRaw) {
      const normalizedSize = normalizeDataRingSize(dataRingSizeRaw);
      return removeOptionsExcept(normalizedSize);
    }

    // 3. Vendor-specific logic
    if (vendor.includes('JOHN HARDY')) {
      const sizesToRemove = $gender === 'Womens'
        ? ['4 1/2', '5 1/2', '6 1/2', '7 1/2', '8 1/2', '9', '9 1/2', '10', '10 1/2', '11', '11 1/2', '12']
        : ['4 1/2', '5', '5 1/2', '6', '6 1/2', '7 1/2', '8', '8 1/2', '9 1/2', '10 1/2', '11 1/2'];
      const fallback = $gender === 'Womens' ? '5' : '9';
      return removeOptions(sizesToRemove, fallback);
    }

    // 4. SKU-based logic
    if (sku.includes('RMOM')) {
      return removeOptions(['4 1/2', '10 1/2', '11', '11 1/2', '12']);
    }

    // 5. Gender-specific logic
    if ($gender === 'Womens') {
      return removeOptions(['4 1/2', '5', '5 1/2', '8 1/2', '9', '9 1/2', '10', '10 1/2', '11', '11 1/2', '12'], '6');
    }

    if ($gender === 'Mens') {
      return removeOptions(['4 1/2', '5', '5 1/2', '6', '6 1/2', '7', '7 1/2', '8', '8 1/2'], '9');
    }

    // 6. Default fallback logic
    removeOptions(['4 1/2', '5', '5 1/2', '8 1/2', '9', '9 1/2', '10', '10 1/2', '11', '11 1/2', '12'], '6');
  };

  const hideCustomEngraving = () => {
    if ($('.collection__products').length) {
      $('.collection__products .product-grid-item__info').each(function () {
        const title = $(this).find('.product-grid-item__title').text();

        if (title === 'Custom Engraving') {
          $(this).hide();
        }
      })
    }
  }

  const hideEmptySpecifications = () => {
    try {
      $('.product__accordion__content.specifications p').each(function (index) {
        if (!$(this).text().split(': ')[1].length) {
          $(this).addClass('titan-hide');
        }

        if ($(this).text().split(':')[0] === 'Case Depth Rating') {
          if (ShopifyAnalytics.meta.product.type !== 'WATCHES & CLOCKS') {
            $(this).addClass('titan-hide');
          }
        }

        if ($(this).text().split(':')[0] === 'Case Size (mm)') {
          if (ShopifyAnalytics.meta.product.type !== 'WATCHES & CLOCKS') {
            $(this).addClass('titan-hide');
          }
        }
      });
    } catch (err) {
      console.error('error caught in hideEmptySpecifications(), err: ', err);
    }
  }

  const hideDuplicateTryOn = () => {
    try {
      $('.picupmedia_container').each(function () {
        if ($(this).find('button').length > 1) {
          const dupeBtn = $(this).find('button')[1];
          $(dupeBtn).hide();
        }
      });
    } catch (err) {
      console.error('error caught in hideDuplicateTryOn, err: ', err);
    }
  }

  const moveIcons = () => {
    $('.product__icon__row').insertBefore('.product__submit__holder');
  }

  document.addEventListener('theme:cart:added', addPendingEngravingToCart);

  document.addEventListener("DOMContentLoaded", function () {
    try {
      if (document.location.href.includes('/products')) {
        $('.product-see-in-store button').on('click', handleSeeInStoreClick);
        $('.engraving-checkbox-container input').on('click', handleEngravingClick);
        $('.engraving-textbox-container input').on('input', handleEngravingText);
        $('.product-add-to-cart button').on('click', handleAddToCart);
        hideEmptySpecifications();
        moveIcons();
        if ($('#ring-size-selector').length) {
          hideRingSizes();

          updateRingSizeInfo();
        }
        if (document.location.href.includes('/search') || document.location.href.includes('/collections')) {
          hideCustomEngraving();
        }
      }

      if (document.location.href.includes('/pages/see-in-store') || document.location.href.includes('/pages/rc-see-in-store')) {
        populateSeeInStore();
      }

      setTimeout(() => {
        if ($('.picupmedia_container').length) {
          hideDuplicateTryOn();
        }
      }, "300");
    } catch (err) {
      console.error('error caught in dom ready in custom.js, err: ', err);
    }
  });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();